module.exports = __webpack_public_path__ + "static/media/tabletennislive.8d1f6d6d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/tabletennislive.svg
// module id = 400
// module chunks = 7